
import { mapState } from 'vuex'
import { setMetaRobots } from '@/utils/utils'
export default {
  head() {
    return {
      title:
        this.$t('home.footer.warranty_policy') + ' - ' + this.$t('home.title'),
      meta: [setMetaRobots(false)]
    }
  },
  computed: {
    ...mapState({
      setting: (state) => state.setting
    })
  },
  mounted() {
    document.title = this.$t('home.title')
  }
}
